
export const btnTimes = {
    t1:[52.7,57],
    t2:[103,106],
    t3:[134,138.9],
    t4:[12, 16],
    t5:[120,120.3]
}